import {ga4TrackSimpleEvent} from "../../modules/analytics";
import {deferTask} from "../defer";
import {createCarousel} from "../carousel";
import {registerProductGalleryInit, setProductGalleryApi} from "../product-page-gallery-bridge";
import {documentLoadEvent} from "../../modules/events";
import {isDesktop} from "../../modules/devices";

export function initNativeGallery(slider, productType)
{
    setProductGalleryApi(null);
    if (!slider) return;

    const gallery = slider.closest('.product-gallery') || slider;
    if (!gallery || !gallery.classList.contains('product-gallery')) return;

    const slideCount = gallery.querySelectorAll('.product-gallery__slide').length;
    const paginator = gallery.querySelector('.product-gallery__pagination');

    if (slideCount <= 1) {
        const prevButton = gallery.querySelector('.product-gallery__prev');
        const nextButton = gallery.querySelector('.product-gallery__next');
        if (prevButton) prevButton.classList.add('d-none');
        if (nextButton) nextButton.classList.add('d-none');
        if (paginator) paginator.classList.add('d-none');
        return;
    }

    const api = createCarousel(gallery, {
        selectors: {
            viewport: '.product-gallery__viewport',
            track: '.product-gallery__track',
            slide: '.product-gallery__slide',
            prev: '.product-gallery__prev',
            next: '.product-gallery__next',
            pagination: '.product-gallery__pagination',
            paginationItem: '.product-gallery__pagination-item'
        },
        loop: false,
        mode: 'percent',
        slidesPerView: 1,
        startIndex: 0,
        swipe: true,
        suppressClickOnSwipe: true,
        arrows: {mode: 'toggle-hidden'},
        watchResize: true,
        onSelect: function(index) {
            if (paginator) {
                const numberEl = paginator.querySelector('.number-of-page');
                if (numberEl) numberEl.innerHTML = String(index + 1);
            }
            // GTM handles the push synchronously; run it after the swipe has painted so it stays out of INP.
            deferTask(function() {
                ga4TrackSimpleEvent({
                    event: 'product_page',
                    method: 'image_scroll',
                    product_type: productType || '-'
                });
            });
        }
    });

    setProductGalleryApi(api);
}

registerProductGalleryInit(initNativeGallery);

documentLoadEvent(function() {
    if (isDesktop()) return;
    let productType = '-';
    const richCard = document.querySelector('script[type="application/ld+json"]');
    if (richCard) {
        try {
            const jsonld = JSON.parse(richCard.innerText);
            productType = (jsonld ? jsonld.category || '' : '').toLowerCase();
        } catch (e) {}
    }
    initNativeGallery(document.querySelector('main.product .image-slider'), productType);
});
